export default __webpack_public_path__ + "static/image1-4da386788cc119ab81fe6fd2db15fa75.gif";